export enum columnType {
    H_S = 'H-S',
    H_M1M2 = 'H-M1M2',
    H_L = 'H-L',
}